<template>
  <div id="app">
    <router-link to="/"></router-link>
    <router-view />

    <div class="suspensionBtn" v-show="!ismo">
      <div
        class="top"
        @click="tobacktop"
        :class="{ appear: top >= 200, noappear: top < 200 }"
      >
        <i class="el-icon-top"></i><br />
        回到顶部
      </div>
    </div>
  </div>
</template>

<script>
let timer = null
let _this
export default {
  data() {
    return {
      ismo: false,
      top: 0,
      signupshow: false,
    }
  },
  created() {
    _this = this
    // _this.verification();
    this.ismo = this.isMobile()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    isMobile() {
      var ua = navigator.userAgent
      var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        isMobile = isIphone || isAndroid
      if (isMobile) {
        return true
      }
      return false
    },
    handleScroll() {
      this.top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
    },
    tobacktop() {
      timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop
        let ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed
        if (osTop === 0 || this.osTop < 0) {
          clearInterval(timer)
        }
      }, 18)
    },
  },

  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
}
</script>
<style lang="less">
@import './common/css/base.css';
@import './common/css/common.less';
.top {
  background-color: #fd4a29;
  width: 68px;
  padding: 15px 5px;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  text-align: center;
}

.suspensionBtn {
  display: block;
  z-index: 1000;
  position: fixed;
  bottom: 100px;
  right: 50px;
  transition: opacity 0.5s;
  img {
    width: 70px;
    height: 70px;
  }
}
.appear {
  display: block;
  img {
    cursor: pointer;
  }
  animation-name: fadeIn; /*动画名称*/
  animation-duration: 0.3s; /*动画持续时间*/
  animation-iteration-count: 1; /*动画次数*/
  animation-delay: 0s; /*延迟时间*/
}
.noappear {
  display: none;
}
.tooltips {
  p {
    font-size: 12px;
    line-height: 20px;
  }
  img {
    width: 150px;
    height: 150px;
  }
  .service {
    font-size: 16px;
  }
  .txt_cen {
    text-align: center;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0; /*初始状态 透明度为0*/
  }
  100% {
    opacity: 1; /*结尾状态 透明度为1*/
  }
}
.el-tooltip__popper.is-light {
  border: none !important;
  box-shadow: 0px 0px 5px 1px #e8e8e8;
}
.el-tooltip__popper[x-placement^='left-start'] .popper__arrow {
  border: none;
  box-shadow: 0px 0px 5px 1px #242323;
}
</style>
